import { Pipe, PipeTransform } from "@angular/core";
import { ServiceData } from "../../providers/services";

@Pipe({
  name: "group_service",
})
export class GroupServicePipe implements PipeTransform {

  constructor(
    private serviceData: ServiceData,
  ) { }

  public transform(idGroup: string, clientId: string) {
    return this.serviceData.getGroupById(clientId, idGroup);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/group-service/group-service.ts